import axios from 'axios'
import Cookies from 'js-cookie'
import { getAccessToken } from '@/utils/userInfo'
import router from '@/router'
import store from '@/store'
import qs from 'qs'
import { clearLoginInfo } from '@/utils'
import isPlainObject from 'lodash/isPlainObject'
import Vue from 'vue'
import VueI18n, { messages } from '@/i18n'
const messagesConst = messages[VueI18n.locale]

const http = axios.create({
  baseURL: window.SITE_CONFIG['apiURL'],
  // baseURL: `/api`,
  timeout: 1000 * 180,
  withCredentials: true
})

/**
 * 请求拦截
 */
http.interceptors.request.use(
  (config) => {
    // console.log(config)
    config.headers['Accept-Language'] = Cookies.get('language') || 'zh-CN'
    config.headers['content-type'] = 'application/json;charset=UTF-8'
    config.headers['Authorization'] = ''
    // config.headers['content-type'] = 'application/x-www-form-urlencoded'
    const serverIp = localStorage.getItem('server-ip')
    if (serverIp) {
      config.headers['server-ip'] = serverIp.trim()
    }
    let url = config.url
    if (url.includes('?')) {
      url = url.split('?')[0]
    }
    let urls = [
      '/auth/login',
      '/front/consumer/sendVerificationCode',
      '/front/consumer/sendVerificationCodeByCaptcha',
      '/front/consumer/checkMessageCode',
      '/front/consumer/user/register',
      '/auth/oauth/token',
      '/front/consumer/user/invitationRegister'
    ]
    if (
      getAccessToken() &&
      getAccessToken() !== 'undefind' &&
      getAccessToken() !== 'null'
    ) {
      if (!urls.includes(url)) {
        config.headers['Authorization'] = 'Bearer ' + getAccessToken() || ''
      }
      if (url.indexOf('/auth/oauth/token') > -1) {
        config.headers['Authorization'] = 'Bearer ' + getAccessToken()
      }
    }
    // 如果是渠道商的接口 加个参数

    let plcInfo = {}
    if (url.indexOf('/front/oms/plc') !== -1 && sessionStorage.getItem('plcUserInfo')) {
      plcInfo.defaultCompanyId = JSON.parse(sessionStorage.getItem('plcUserInfo') || '{}').defaultCompanyId
    }
    // 默认参数
    var defaults = {}
    // 防止缓存，GET请求默认带_t参数
    if (config.method === 'get') {
      // config.params = config.params
      let _noLoading = config.params ? config.params._noLoading : false
      if (_noLoading) {
        delete config.params._noLoading
      }
      config.params = {
        ...config.params,
        ...{
          _t: new Date().getTime()
        }
      }
      if (!_noLoading) {
        store.commit('setLoadStatus', true)
      }
    }
    if (isPlainObject(config.params)) {
      config.params = {
        ...plcInfo,
        ...defaults,
        ...config.params
      }
    }
    if (isPlainObject(config.data)) {
      // console.log('config.data', config.headers['content-type'])
      config.data = {
        ...plcInfo,
        ...defaults,
        ...config.data
      }
      if (
        /^application\/x-www-form-urlencoded/.test(
          config.headers['content-type']
        )
      ) {
        config.data = qs.stringify(config.data)
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * 响应拦截
 */
http.interceptors.response.use(
  (response) => {
    if (response.config.method === 'get') {
      store.commit('setLoadStatus', false)
    }
    // login处理
    if (response.data.access_token) {
      response.data['data'] = response.data
      response.data['code'] = 0
    }
    // 返回体Data转成data
    if (response.data.Data) {
      response.data['data'] = response.data.Data
    }
    if (response.data.data) {
      if (response.data.data.count) {
        response.data.data.count = Number(response.data.data.count)
      }
    }
    if (response.data.code === 401 || response.data.code === 10001) {
      clearLoginInfo()
      router.replace({
        name: 'login'
      })
      return Promise.reject(response.data.msg)
    } else if (
      response.data.code &&
      process.env.VUE_APP_HOLD_ALERT_ERRORCODE &&
      process.env.VUE_APP_HOLD_ALERT_ERRORCODE.toString() === response.data.code.toString()
    ) {
      /**
       * 特殊错误码，开发900001，正式900000
       * 该错误码不提示错误信息
       */
    } else if (
      response.data.code &&
      response.data.code !== 0 &&
      response.data.code !== 10004 &&
      response.data.code !== 10007
    ) {
      if (
        response.data.resultCode === '0' ||
        response.config.url.indexOf(
          'front/consumer/shoppingcart/checkCommodityPromotion'
        ) > -1 ||
        response.data.code === 90001 ||
        response.config.url.indexOf('front/consumer/user/can-canceled') > -1 ||
        response.config.url.indexOf('front/consumer/user/canceled') > -1
      ) {
        //
      } else {
        Vue.prototype.$message.error(
          response.data.message || response.data.resultMessage || ''
        )
        // if (response.data.message || response.data.resultMessage) {
        //   let message = encodeURIComponent(response.data.message)
        //   http.get(`/inter/interface/baidu/translate?toType=1&message=${message}`).then(res => {
        //     if (res && res.data && res.data.data) {
        //       Vue.prototype.$message.error(res.data.data)
        //     } else {
        //       Vue.prototype.$message.error(messagesConst.message.error)
        //     }
        //   })
        // }
      }
      // throw response.data
    }
    return response
  },
  (error) => {
    if (error.response) {
      if (error.response.config.method === 'get') {
        store.commit('setLoadStatus', false)
      }
      if (error.response.status === 401) {
        clearLoginInfo()
        router.replace({
          name: 'login'
        })
        return
      }
    } else {
      store.commit('setLoadStatus', false)
      return
    }
    Vue.prototype.$message.error(
      messagesConst.prompt.error ||
        (error.response
          ? error.response.data.message || error.response.data.resultMessage
          : '')
    )
    return Promise.reject(error)
  }
)

export default http
